import * as Yup from 'yup'

const CmsFeaturedSellerCreateFormSchema = Yup.object().shape({
  seller_id: Yup.number()
    .required('Required'),
  bio: Yup.string()
    .required('Required'),
  occupation: Yup.string()
    .required('Required')
})

export default CmsFeaturedSellerCreateFormSchema
